import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const Container = styled(Box)({
  width: '100vw',
  height: '100vh',
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '16px', paddingBottom: '16px',
  background: 'center center / cover no-repeat url(/images/back-bkg-sm.png)',
});

export default Container;
